import * as React from 'react';
const EyeClosedIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.689 1.982a.5.5 0 0 0-.708.707l3.13 3.13a13.4 13.4 0 0 0-3.217 3.945.5.5 0 0 0-.006.46v.002l.003.004.007.015a4 4 0 0 0 .13.24 14.2 14.2 0 0 0 1.945 2.645c1.35 1.438 3.388 2.945 6.027 2.945h.008a7.5 7.5 0 0 0 4.078-1.282l3.225 3.226a.5.5 0 1 0 .708-.707l-3.522-3.523-.01-.008-8.269-8.27-.008-.008zm3.133 4.547a12.4 12.4 0 0 0-2.917 3.473 13.2 13.2 0 0 0 1.799 2.443c1.263 1.348 3.055 2.628 5.292 2.63a6.5 6.5 0 0 0 3.367-1.005l-1.91-1.91a2.6 2.6 0 0 1-1.46.482 2.593 2.593 0 0 1-2.635-2.635 2.6 2.6 0 0 1 .482-1.46zM8.563 9.27a1.592 1.592 0 0 0 1.413 2.373 1.6 1.6 0 0 0 .754-.206zM2.335 10l-.447.225zm6.316-4.92a6 6 0 0 1 1.348-.154H10c2.24 0 4.032 1.28 5.297 2.629a13.2 13.2 0 0 1 1.799 2.443q-.57 1.013-1.319 1.903a.5.5 0 0 0 .766.644c.6-.713 1.124-1.487 1.563-2.31a.5.5 0 0 0 .006-.46l-.003-.005-.008-.015a6 6 0 0 0-.13-.24 14.2 14.2 0 0 0-1.945-2.645c-1.348-1.437-3.387-2.944-6.025-2.944a7 7 0 0 0-1.578.18.5.5 0 0 0 .228.974"
      fill="currentColor"
    />
  </svg>
);
export default EyeClosedIcon;
